<div class="container-fluid">
    <h1 class="h4 pb-3">New contract</h1>
    <div class="contract-new-card">
        <cdss-contract-form idPrefix="new-contract"
                            [saving]="saving"
                            [codeError]="codeError"
                            (save)="onSave($event)">
            <a class="btn btn-light" [routerLink]="listRoute" data-testid="contract-cancel-link">Cancel</a>
        </cdss-contract-form>
    </div>
</div>
